export default {"src":"/_next/static/media/unsecured-business-loan.d16d05cc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};